import {
    PRICE_L_PEAK_SEASON_WEEK,
    PRICE_L_PEAK_SEASON_SUN_THUR,
    PRICE_L_PEAK_SEASON_THUR_SUN,
    PRICE_L_LOW_SEASON_WEEK,
    PRICE_L_LOW_SEASON_SUN_THUR,
    PRICE_L_LOW_SEASON_THUR_SUN,
    PRICE_L_LOW_SEASON_DAY,
    PRICE_S_PEAK_SEASON_WEEK,
    PRICE_S_PEAK_SEASON_SUN_THUR,
    PRICE_S_PEAK_SEASON_THUR_SUN,
    PRICE_S_LOW_SEASON_WEEK,
    PRICE_S_LOW_SEASON_SUN_THUR,
    PRICE_S_LOW_SEASON_THUR_SUN,
    PRICE_S_LOW_SEASON_DAY,
    PRICE_F_PEAK_SEASON_WEEK,
    PRICE_F_PEAK_SEASON_DAY,
    PRICE_F_LOW_SEASON_WEEK,
    PRICE_F_LOW_SEASON_DAY
} from "../constants.js"

export const SWEDISH_TRANSLATIONS = {
    text: {
        home: 'Hem',
        email: "E-post",
        welcome_to: "Välkommen till",
        hjortronvagen: "Hjortronvägen",
        rent_a_cabin: "Hyr en stuga i",
        beautiful_salen: "vackra Sälen",
        email_taken: "Den E-post du angett är redan tagen. Om detta är din E-post, kontakta oss.",
        general_error: "Något gick fel. Försök igen senare. Om detta fortsätter hända, kontakta oss.",
        Continue: "Fortsätt",
        Continue_header: "Gå vidare",
        Book_now: "Boka nu!",
        Logout: "Logga ut",
        salen: "Sälen",
        salen_info_text: "Hyr en stuga i Sälen, Dalarna, Sveriges närmsta fjäll! \
                  I Sälen finns något för alla. På sommaren kan man vandra, fiska, bada, bika mm. \
                  På vintern kan man åka skidor på alla ledder. \
                  Det finns ett stort utbud av fritidssysselsättning såsom skidåkning, hundspann, scoterleder, \
                  äventyrsbad, bio, SPA, restauranger och andra nöjen. Det finns något som passar alla! \
                  Huset är beläget nära Gammelgården på Högfjället, på",
        Hotel: "Hotell",
        Location: "Området",
        more_info: "Mer info",
        more_info_and_pictures: "Mer info och bilder",
        small_cabin: "Lillstugan",
        large_cabin: "Storstugan",
        family_cabin: "Familjestugan",
        small_cabin_info_short: "Den mindre stugan med fyra bäddar, ca 50 m², allrum med köksavdelning, ett sovloft, ett badrum.",
        large_cabin_info_short: "Den större stugan med sex bäddar, ca 70 m², allrum med köksavdelning, två sovrum, ett badrum.",
        contact_us: "Kontakta oss!",
        contact_us_text: "Kontakta oss om du har några frågor angående stugor eller bokning!",
        admin: "Admin",
        bookings: "Bokningar",
        book: "Boka",
        book_text_short: "Vet du redan allt du behöver veta? Gå direkt till bokningen!",
        book_family_cabin: "Klicka här för att boka familjestugan!",
        email_validation_text: "Du behöver ange en giltig email.",
        email_address: "Email",
        enter_email: "Ange email",
        phone: "Telefonnummer",
        enter_phone: "Ange telefonnummer",
        first_name: "Förnamn",
        enter_first_name: "Ange förnamn",
        last_name: "Efternamn",
        enter_last_name: "Ange efternamn",
        cabin: "Stuga",
        select_cabin: "Välj stuga",
        date: "Datum",
        dates: "Datum",
        start_date: "Startdatum",
        end_date: "Slutdatum",
        more: "Mer",
        date_validation_text_peak_season: "Under högsäsong kan du endast välja torsdagar eller söndagar. Skicka ett mail till hjortronvagen15@gmail.com om \
                            du gärna vill boka dessa dagar så ska vi se om vi kan ordna det.",
        date_validation_text_holidays: "Under lov och högtider (sportlov, vasaloppsveckan, påsk, påsklov, julvecka och nyår) kan du endast hyra veckovis. Det går bra att hyra färre dagar men då betalar man fortfarande en veckas hyra. I så fall: boka en vecka och sedan under meddelanden ange vilka datum du önskar att hyra, så uppdaterar vi bokningen med korrekt datum.",
        date_validation_text_minimum: "Bokningen måste vara minst en natt lång.",
        book_login_text_1: "Boka enklare och håll koll på dina bokningar genom att",
        book_login_text_2: "skapa ett konto",
        book_login_text_3: ". Har du redan ett konto?",
        book_login_text_4: "Logga in!",
        date_overlaps_error: "Datum överlappar med befintlig bokning",
        memory_note: "Är det något du vill att vi ska veta?",
        message: "Meddelande",
        enter_memory_note: "Ange notering",
        users: "Användare",
        profile: "Profil",
        contacted: "Kontaktad",
        not_contacted: "Ej kontaktad",
        payed: "Betald",
        unpayed: "Obetald",
        name: "Namn",
        weeks: "Veckor",
        extra_info: "Extra info",
        note: "Notering",
        created: "Skapad",
        user_type: "Användartyp",
        show_old_bookings: "Visa gamla bokningar",
        edit_user: "Ändra användare",
        password: "Lösenord",
        enter_password: "Ange lösenord",
        repeat_password: "Upprepa lösenord",
        standard: "Standard",
        family: "Familj",
        familyplus: "Delägare",
        save: "Spara",
        send: "Skicka",
        delete: "Ta bort",
        send_confirmation_email: "Skicka bokningsbekräftelse",
        send_key_email: "Skicka låsbox-kod",
        send_payment_reminder_email: "Skicka betalningspåminnelse",
        show_confirmation: "Visa bokningsbekräftelse",
        booking_confirmation: "Bokningsbekräftelse",
        saved: "Sparad",
        passwords_not_match: "Lösenorden matchar ej",
        are_you_sure_delete_user: "Är du säker på att du vill ta bort denna användare?",
        delete_user: "Ta bort användare",
        delete_cabin_price: "Ta bort pris",
        cancel: "Avbryt",
        are_you_sure_update_user: "Är du säker på att du vill uppdatera denna användare?",
        are_you_sure_delete_booking: "Är du säker på att du vill ta bort denna bokning?",
        are_you_sure_resend_confirmation_email: "Är du säker på att du vill skicka om bokningsbekräftelsen? Detta kommer skicka ett mail till bokningens email-adress.",
        are_you_sure_resend_key_email: "Är du säker på att du vill skicka koden till låsboxen? Detta kommer skicka ett mail till bokningens email-adress.",
        are_you_sure_send_payment_reminder_email: "Är du säker på att du vill skicka en betalningspåminnelse? Detta kommer skicka ett mail till bokningens email-adress.",
        are_you_sure_update_booking: "Är du säker på att du vill uppdatera denna bokning?",
        are_you_sure_update_cabin_price: "Är du säker på att du vill uppdatera detta pris?",
        are_you_sure_delete_cabin_price: "Är du säker på att du vill ta bort detta pris?",
        confirmation_email_sent: "Bokningsbekräftelsen skickades",
        confirmation_email_fail: "Bokningsbekräftelsen misslyckades att skickas",
        key_email_sent: "Koden skickades",
        key_email_fail: "Koden misslyckades att skickas",
        payment_reminder_email_sent: "Betalningspåminnelsen skickades",
        payment_reminder_email_fail: "Betalningspåminnelsen misslyckades att skickas",
        delete_booking: "Ta bort bokning",
        select_user: "Välj användare",
        user: "Användare",
        edit_booking: "Ändra bokning",
        are_you_sure_update_profile: "Är du säker på att du vill uppdatera din profil?",
        are_you_sure_delete_profile: "Är du säker på att du vill ta bort din profil?",
        register_user: "Skapa användare",
        forgot_password: "Glömt lösenord",
        username: "Användarnamn",
        enter_username: "Ange användarnamn",
        terms_of_condition: "Jag accepterar att de uppgifter jag angivit sparas till dess att jag upphäver mitt konto. Jag accepterar även att de uppgifter jag angivit får användas till att kontakta mig angående mina bokningar.",
        terms_of_condition_booking: "Jag accepterar att de uppgifter jag angivit sparas. Jag accepterar även att de uppgifter jag angivit får användas till att kontakta mig angående min bokning. Du kan kontakta oss om du vill att uppgifterna tas bort.",
        reset_code: "Återställningskod",
        enter_reset_code: "Ange återställningskod",
        new_password: "Nytt lösenord",
        forgot_password_text: "Vi kommer skicka en återställningskod till din email som du kan använda i nästa steg. Om du redan har en återställningskod,",
        click_here: "klicka här",
        reset_password: "Återställ lösenord",
        send_code: "Skicka kod",
        password_has_been_reset: "Ditt lösenord har nu blivit återställt. Du kan nu logga in med ditt nya lösenord.",
        login: "Logga in",
        back: "Tillbaka",
        edit_profile: "Ändra profil",
        optional: "frivillig",
        notes: "Noteringar",
        price: "Pris",
        enter_price: "Ange pris",
        sek: "kr",
        wrong_credentials: "Fel användarnamn eller lösenord",
        search: "Sök",
        night: "natt",
        nights: "nätter",
        your_information: "Dina uppgifter",
        additional_information: "Ytterligare uppgifter",
        booking: "Bokning",
        desired_dates: "Vilka datum vill du boka?",
        located_at: "Belägen på",

        cabin_read_more: "Läs mer om stugan",
        booking_payment_information: "Betalning sker via banköverföring. Mer information om betalning hittar du i din bokningsbekräftelse efter detta steg. Bokningen är reserverad efter att bokningen är genomförd och bekräftad efter betalning. Det går bra att kontakta hjortronvagen15@gmail.com för att avboka under reserveringstiden utan någon kostnad.",
        small_cabin_short_description: "1 sovloft, 4 bäddar",
        large_cabin_short_description: "2 sovrum, 6 bäddar",
        family_cabin_short_description: "6 bäddar",
        available_cabins: "Välj stuga",
        select_dates: "Välj datum",
        not_available: "Ej tillgängliga",
        not_available_singular: "Ej tillgänglig",
        select: "Välj",
        
        weeks_input_info: "Veckor (skriv in som kommaseparerade siffror, ex 1,2,3)",
        enter_weeks: "Ange veckor",
        enter_name: "Ange namn",
        edit_price: "Ändra pris",
        create_price: "Skapa pris",
        price_day: "Pris per dag",
        price_week: "Pris per vecka",
        price_sun_to_thur: "Pris för söndag till torsdag",
        price_thur_to_sun: "Pris för torsdag till söndag",
        create: "Skapa",
        weeks_format_error: "Veckor har felaktig formatering",
        display_name: "Visningsnamn",
        display_name_en: "Visningsnamn (engelska)",
        block_partial_periods: "Blockera delperioder",
        block_partial_periods_info_text: "Om denna är ibockad kommer användare endast kunna boka torsdagar och söndagar.",
        
        // Family info texts
        info_to_family: "Info till familjen",
        info_family_header_1: "Priser för familjen finns under informationen av stugorna samt räknas ut när man gör en bokning.",
        dec_to_apr: "december-april",
        per_week_1: "1 vecka = " + PRICE_F_PEAK_SEASON_WEEK + "kr",
        per_day_1: "Per dygn = " + PRICE_F_PEAK_SEASON_DAY + "kr",
        additional_guests_1: "Om man har vänner som bor i samma stuga läggs det på ytterligare pris för ett dygn på totalpris. När ni bokar, kryssa i rutan att du tar med vänner för att priset ska räknas ut korrekt.",
        may_to_nov: "maj-november",
        per_week_2: "1 vecka = " + PRICE_F_LOW_SEASON_WEEK + "kr",
        per_day_2: "Per dygn = " + PRICE_F_LOW_SEASON_DAY + "kr",
        additional_guests_2: "Om man har med sig kompis i samma stuga läggs det på" + PRICE_F_LOW_SEASON_DAY + "kr på totalpris. När ni bokar, skriv i notering att du tar med vänner.",
        about_family_apartment: "Ang familjelägenheten",
        about_family_apartment_text: "Denna är främst till för delägarna av stugan. Om du vill hyra måste du först kolla med någon av delägarna alternativt höra av dig till",
        about_family_apartment_text_2: "Lämna alltid nyckeln i låsboxen när du lämnar familjelägenheten.",
        
        // Cabin texts
        the_cabin: "Stugan",
        l_apartment_text: "Vår större stuga, på ca 70 m², är uppdelad på två våningar. På nedervåningen finner du en rymlig hall, ett badrum med dusch och wc, ett kök samt ett allrum. \
        Köket är fullt utrustat med spis med ugn, kylskåp, frys, diskmaskin, mikrovågsug, kaffebryggare och vattenkokare. \
        I allrumet hittar du en TV (ej kabel-TV) och en stor soffa där alla kan sitta och umgås. \
        På övervåningen finner du två sovrum. Det större sovrummet har fyra bäddar medan det mindre har två (90cm). Det finns även två extrasängar.",
        transport: "Transport",
        transport_text: "Tack vare stugans praktiska läge kan du enkelt ta del av vad Sälen har att erbjuda, även om du inte har tillgång till bil. Bara ett par minuters promenad från stugan, vid stora vägen, ligger \
        Gammelgården. Här kan du äta och dricka gott i mysig miljö. Intill Gammelgården ligger busshållsplatsen där bussen från Mora stannar. Här kan du också ta skidbussarna till Sälens olika liftsystem. \
        Om du föredrar att undvika busstabeller hittar du även här en transportlift som tar dig till Högfjället samt en skidbacke som tar dig till Lindvallen.",
        other: "Övrigt",
        other_text: "Tillträde på ankomstdag är från kl 14:00. Utcheckning på avresedag sker senast 11:00. \
        Avresestädning ingår ej. Husdjur och rökning är ej tillåtet. Alla i sällskapet ska vara fyllda 18 år om dessa inte är i målsmans sällskap. \
        Om man önskar hyra vid lov och högtider (sportlov, vasaloppsveckan, påsk, påsklov, julvecka och nyår) kan man endast hyra veckovis. Det går att hyra färre dagar men då betalar man fortfarande en veckas hyra.",
        
        f_apartment_text: "Du vet redan allt om denna stuga!",

        peak_season_weeks: "Högsäsongsveckor: 1, 7-10, 15-18, 52",
        low_season_weeks: "Lågsäsongsveckor: övriga veckor som inte nämns ovan",
        prices: "Priser",
        income: "Intäkter",
        peak_season: "Högsäsong",
        low_season: "Lågsäsong",
        l_peak_season_1: PRICE_L_PEAK_SEASON_WEEK + ":- söndag till söndag",
        l_peak_season_2: PRICE_L_PEAK_SEASON_SUN_THUR + ":- Söndag till torsdag",
        l_peak_season_3: PRICE_L_PEAK_SEASON_THUR_SUN + ":- torsdag till söndag",
        l_low_season_single_day: PRICE_L_LOW_SEASON_DAY + ":- per dag",
        l_low_season_1: PRICE_L_LOW_SEASON_WEEK + ":- söndag till söndag",
        l_low_season_2: PRICE_L_LOW_SEASON_SUN_THUR + ":- Söndag till torsdag",
        l_low_season_3: PRICE_L_LOW_SEASON_THUR_SUN + ":- torsdag till söndag",
        
        s_apartment_text: "Detta är vår mindre stuga, på ca 50 m². På nedervåningen finner du en hall, ett badrum med dusch och wc, ett kök samt ett allrum. \
        Köket är fullt utrustat med spis med ugn, kylskåp, frys, diskmaskin, mikrovågsug, kaffebryggare och vattenkokare. \
        I allrumet hittar du en TV (ej kabel-TV), en soffa och två fåtöljer. \
        På sovloftet finner du fyra bäddar (90cm).",

        s_peak_season_1: PRICE_S_PEAK_SEASON_WEEK + ":- söndag till söndag",
        s_peak_season_2: PRICE_S_PEAK_SEASON_SUN_THUR + ":- Söndag till torsdag",
        s_peak_season_3: PRICE_S_PEAK_SEASON_THUR_SUN + ":- torsdag till söndag",
        s_low_season_single_day: PRICE_S_LOW_SEASON_DAY + ":- per dag",
        s_low_season_1: PRICE_S_LOW_SEASON_WEEK + ":- söndag till söndag",
        s_low_season_2: PRICE_S_LOW_SEASON_SUN_THUR + ":- Söndag till torsdag",
        s_low_season_3: PRICE_S_LOW_SEASON_THUR_SUN + ":- torsdag till söndag",

        // Cabin texts end

        sek_sun_to_sun: ":- söndag till söndag",
        sek_sun_to_thur: ":- söndag till torsdag",
        sek_thur_to_sun: ":- torsdag till söndag",
        sek_per_week: ":- per vecka",
        sek_per_day: ":- per dag",
        
        page_not_found: "Sidan hittades inte",
        friends_included: "Jag har vänner med mig",
        friends_included_admin: "Har vänner med sig (endast relevant för familj)",
        enter_information: "Ange information manuellt",
        me: "Min användare",

        small_cabin_instructions: "Lillstugan är lägenheten till vänster på husets kortsida.",
        large_cabin_instructions: "Storstugan är ingången till vänster på husets framsida.",

        from: "från",
        to: "till",
        kl: "kl.",
        booking_number: "Bokningsnummer",
        address: "Adress",
        your_notes: "Din minnesnotering",

        booking_completed_intro_text_1: "Tack för din bokning. Dessa datum är nu reserverade. Nedan kan du se information om betalning samt vistelse. Du kommer även få denna bokningsbekräftelse på din email, kolla även skräppost. Om du har ett konto kan du alltid se dina bokningar i din profil.",
        booking_completed_intro_text_2: "Om du har några ytterligare frågor, maila gärna",
        booking_completed_intro_text_3: "Om det är frågor relaterade till din bokning, ange bokningsnumret.",
        
        booking_completed_payment_text_1: "Skall insättas på",
        booking_completed_payment_text_2: "Kontonummer",
        booking_completed_payment_text_3: "OBS! Ange namn och datum vid betalning.",
        booking_completed_payment_text_4: "Bokningen är bekräftad först efter att hyran är inbetald på ovanstående konto.",
        booking_completed_payment_text_4_5: "Betalning sker helst direkt men senast 1 månad innan bokningens startdatum.",
        booking_completed_payment_text_5: "Vid avbokning tidigare än 1 månad innan hyresperioden betalas hela bokningsavgiften åter.",
        booking_completed_payment_text_6: "Vid avbokning senare än 1 månad innan hyresperioden betalas 50% av hela bokningsavgiften åter.",

        booking_completed_arrival_text_1: "Vid ankomst",
        booking_completed_arrival_text_2: "Bilen skall parkeras på parkeringsplatsen på andra sidan vägen så att snöröjning kan ske obehindrat.",
        booking_completed_arrival_text_3: "Parkering på gården endast för i- och urlastning.",
        booking_completed_arrival_text_4_large: "Storstugan är ingången till vänster på husets framsida.",
        booking_completed_arrival_text_4_small: "Lillstugan är lägenheten till vänster på husets kortsida.",
        booking_completed_arrival_text_5: "Nycklar finns i en svart kodbox på höger sida om dörren.",
        booking_completed_arrival_text_6: "Koden meddelas efter slutbetalning och 2 dagar före hyresperioden.",
        
        booking_completed_leaving_text_1: "Hemresa",
        booking_completed_leaving_text_2: "Stugan är städad då du kommer och den skall vara i samma skick när du åker därifrån.",
        booking_completed_leaving_text_3: "Köket skall vara rengjort, alla ytor torkade, spis och ugn, kyl/frys, diskmaskin, micro-ugn rengjord.",
        booking_completed_leaving_text_4: "Inga matvaror skall lämnas kvar.",
        booking_completed_leaving_text_5: "Alla sopor skall lämnas på avfallsplats som finns på Köarskärsområdet.",
        booking_completed_leaving_text_6: "Alla övriga ytor i stugan skall dammtorkas, golv skall dammsugas och torkas, utrustning finns för städ.",
        booking_completed_leaving_text_7: "Skaka mattor utomhus, och vädra sängkläder.",
        booking_completed_leaving_text_8: "Nyckel hängs tillbaka i kodboxen. Avmarkera koden dvs. lämna ej den befintliga koden synlig då du lämnar stugan.",
        
        booking_completed_outro_text_1: "Med önskan om en riktigt härlig vistelse i Sälen!",
        booking_completed_outro_text_2: "Vid problem kontakta:",
        booking_completed_outro_text_3: "eller skriv ett mail till",

        images: "Bilder",
        show_images: "Visa bilder",
        hide_images: "Göm bilder",
        information: "Information",


        username_change_info: "Notera att inloggningen har uppdaterats till att använda email istället för användarnamn. \
        Om du får några problem med inloggningen, eller glömt din email, kontakta oss gärna.",

        
        // ERROR TEXTS!
        
        something_went_wrong: "Något gick fel",
        something_went_wrong_try_later: "Något gick fel, försök gärna senare",

        price_has_changed_warning: "Notera att priset för bokningen har uppdaterats utifrån ändringarna. Du kan även ändra priset manuellt.",

        select_income_dates: "Välj datum att se intäkter mellan.",
        income_family: "Intäkter från familj",
        income_external: "Intäkter från externa",
        income_total: "Totala intäkter",
        select_year: "Välj år",
        select_specific_dates: "Välj specifika datum",
        write_year: "Skriv vilket år du vill se inkomst för.",
        placeholder_year: "År",
        invalid_year: "Ogiltigt år",
        selected_dates: "Valda datum",
    }
};